import {
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import {
  ExpRegSoloNumeros,
  ExpRegSoloNumerosPassport,
  dateformat,
  randomDate,
} from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { login } from '../../../../router/Routes';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import { FechaField } from '../../../accesos/components/FechaField';
import {
  ADMIN_CONST,
  ENTITY_CONST,
  FAMILY_CONST,
  ROOT_CONST,
  STUDENT_CONST,
  TEACHER_CONST,
  USER_CONST,
} from '../../../auth/login/LoginReducer';
import { allDocentesAction } from '../../../control_estudios/docentes/DocentesAction';
import { allEstudiantesAction } from '../../../control_estudios/estudiantes/EstudiantesAction';
import { asignarSeccionsEstudianteService } from '../../../control_estudios/estudiantes/EstudiantesService';
import { saveMatriculasAction } from '../../../control_estudios/matriculas/MatriculasAction';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { allEntidadesAction } from '../../../entidad/entidades/EntidadesAction';
import { allPerfilesAction } from '../../../sistema/perfiles/PerfilesAction';
import SelectFieldPerfilesComponent from '../../../sistema/perfiles/components/SelectFieldPerfiles';
import { saveUsuariosAction } from '../UsuariosAction';
import SelectFieldRolesComponent, { rolesArray } from './SelectFieldRoles';

const FormNuevoUsuariosComponent = ({
  setOpenModalForm = false,
  isUsuarios = true,
  isStudent = false,
  isTeacher = false,
  isPerfiles = true,
  idSeccion = null,
}) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const UsuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);
  const usuariosStore = Redux.useSelector((state) => state.usuarios);
  const perfilesStore = Redux.useSelector((state) => state.perfiles);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);
  const docentesStore = Redux.useSelector((state) => state.docentes);
  const seccionesStore = Redux.useSelector((state) => state.secciones);

  const activo = usuariosStore.activo;

  const initData = {
    dniEscolar: false,
    tipoDni: 'V',
    dni: '',
    pnombre: '',
    snombre: '',
    papellido: '',
    sapellido: '',
    genero: 'M',
    fechaNacimiento: randomDate(),
    tipoSangre: 'O0',
    internet: false,
    actividadExtcur: false,
    idImgFoto: null,
    idPerfil: isTeacher ? 4 : isStudent ? 6 : '',
    correo: '',
    username: '',
    password: '',
    rol: isTeacher
      ? TEACHER_CONST
      : isStudent
      ? STUDENT_CONST
      : !isUsuarios
      ? ENTITY_CONST
      : USER_CONST,
    idEstatus: (isTeacher || isStudent) && !isUsuarios ? 1 : 6,
    idEntEstatus: null,
    idEntidad: '',
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    dni: false,
    pnombre: false,
    papellido: false,
    fechaNacimiento: false,
    username: false,
    correo: false,
    password: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [isSelectEntidad, setIsSelectEntidad] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      if (
        (loginStore.isRoot || loginStore.isAdmin) &&
        perfilesStore.all &&
        perfilesStore.all.length === 0
      ) {
        await allPerfilesAction(dispatch, null);
      }

      if (!loginStore.isRoot && entidadesStore.activo) {
        _handleSetDataField(CONST.entidad.idName, entidadesStore.activo.id);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (!activo) return;
    const { username, correo, perfil } = activo;
    let values = {
      username,
      correo,
      ...perfil,
      idEstatus:
        loginStore.isRoot && isUsuarios
          ? activo.estatus.id
          : activo.estatus.id !== 1
          ? activo.estatus.id
          : UsuEntidadesStore.activo.estatus.id,
    };
    setTimeout(() => setData(values), 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (data.rol === ENTITY_CONST) {
        if (entidadesStore.all && entidadesStore.all.length === 0) {
          await allEntidadesAction(dispatch);
        }
      } else {
        _handleSetDataField(CONST.entidad.idName, null);
        _handleSetDataField(CONST.perfil.idName, null);
      }

      setIsSelectEntidad(data.rol === ENTITY_CONST);

      if (data.rol === TEACHER_CONST) {
        _handleSetDataField(CONST.perfil.idName, 4);
      }

      if (data.rol === STUDENT_CONST) {
        _handleSetDataField(CONST.perfil.idName, 6);
      }

      if (data.rol === FAMILY_CONST) {
        _handleSetDataField(CONST.perfil.idName, 5);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.rol]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];

    if (activo) {
      delete dataError.password;
      delete dataError.idPerfil;
    }

    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!isUsuarios && !entidadesStore.activo && data.rol === ENTITY_CONST) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }

    const idPerfil = data.rol === ENTITY_CONST && !data.idPerfil;
    if (idPerfil) {
      notify('Falta seleccionar el perfil', { warning: true });
      return;
    }

    if (await _validDataForm()) {
      setLoadingSave(true);
      const dataApi = {
        username: data.username,
        correo: data.correo,
        password: data.password,
        perfil: {
          dni: data.dni,
          pnombre: data.pnombre,
          snombre: data.snombre,
          papellido: data.papellido,
          sapellido: data.sapellido,
          fechaNacimiento: dateformat(data.fechaNacimiento, {}),
          internet: data.internet,
          actividadExtcur: data.actividadExtcur,
          dniEscolar: data.dniEscolar,
          tipoSangre: data.tipoSangre,
          tipoDni: data.tipoDni,
          genero: data.genero,
        },
        rol: data.rol,
        idEstatus: data.idEstatus,
        idPerfil: data.idPerfil,
        idEntidad: isUsuarios ? data.idEntidad : entidadesStore.activo.id,
      };

      let res = await saveUsuariosAction(
        { dispatch, notify },
        loginStore.isRoot && !entidadesStore.activo ? true : isUsuarios,
        null,
        null,
        dataApi,
        isUsuarios ? usuariosStore.params : UsuEntidadesStore.params,
      );
      if (res) {
        if (isStudent) {
          if (loginStore.isAdminTeacher && idSeccion) {
            const seccion = seccionesStore.all.find(
              (el) => el.id === idSeccion,
            );

            await asignarSeccionsEstudianteService({
              idSeccion,
              idUsuario: res.id,
              code: seccion.code,
            });
          }

          if ((loginStore.isAdmin || loginStore.isRoot) && idSeccion) {
            const resMatricula = await saveMatriculasAction(
              { dispatch, notify, isAlert: false },
              null,
              {
                nroRegistro: data.dni,
                idEntidad: entidadesStore.activo.id,
                idEstudiante: res.id,
                idSeccion,
              },
              {
                idEntidad: entidadesStore.activo.id,
              },
            );

            if (resMatricula) notify('Matrícula creada correctamente');

            await allEstudiantesAction(dispatch, estudiantesStore.params);
          }
        }
        if (isTeacher) await allDocentesAction(dispatch, docentesStore.params);

        setOpenModalForm(false);
      }
      setLoadingSave(false);
    }
  };

  React.useEffect(() => {
    if (!activo && (data.correo || data.correo !== '')) {
      _handleSetDataField(CONST.username.name, data.correo.split('@')[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.correo]);

  React.useEffect(() => {
    if (!activo && (data.dni || data.dni !== '')) {
      _handleSetDataField(CONST.password.name, data.dni);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.dni]);

  const selectPerfiles = (
    <SelectFieldPerfilesComponent
      value={data.idPerfil}
      isAll={false}
      idsIgnore={[1, 2]}
      // idsIgnore={[1, 2, 4, 5, 6]}
      onChange={(idPerfil) => {
        const perfilSelected = perfilesStore.all.find(
          (el) => el.id === idPerfil,
        );

        setData({
          ...data,
          idPerfil,
          rol: perfilSelected.rol,
        });
      }}
      required={data.rol === ENTITY_CONST}
      error={dataError.idPerfil}
    />
  );

  const selectEntidades = (
    <FormControl fullWidth size="small" error={dataError.entidad}>
      <InputLabel id={`label_${CONST.entidad.idName}`}>
        {CONST.entidad.label}
      </InputLabel>
      <Select
        id={CONST.entidad.idName}
        value={data.idEntidad}
        labelId={`label_${CONST.entidad.idName}`}
        label={CONST.entidad.label}
        onChange={(e) =>
          _handleSetDataField(CONST.entidad.idName, e.target.value)
        }
      >
        {entidadesStore.all.map((el, index) => {
          return (
            <MenuItem key={`entidad-${index}`} value={el.id}>
              {el.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  const selectTipoDni = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.tipoDni.name}`}>
        {CONST.tipoDni.label}
      </InputLabel>
      <Select
        id={CONST.tipoDni.name}
        value={data.tipoDni}
        labelId={`label_${CONST.tipoDni.name}`}
        label={CONST.tipoDni.label}
        onChange={(e) => {
          const dniEscolar = e.target.value === 'CE';

          const perfilSelect = perfilesStore.all.find(
            (el) =>
              el.rol ===
              (e.target.value === 'CE' ? STUDENT_CONST : ENTITY_CONST),
          );

          setData({
            ...data,
            tipoDni: e.target.value,
            dniEscolar,
            rol: perfilSelect.rol,
            idPerfil: perfilSelect.id,
          });
        }}
      >
        <MenuItem value="V">Cédula de identidad</MenuItem>
        <MenuItem value="P">Pasaporte</MenuItem>
        <MenuItem value="E">Extranjero</MenuItem>
        <MenuItem value="CE">Cédula de escolar</MenuItem>
      </Select>
    </FormControl>
  );

  const selectGenero = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.genero.name}`}>
        {CONST.genero.label}
      </InputLabel>
      <Select
        id={CONST.genero.name}
        value={data.genero}
        labelId={`label_${CONST.genero.name}`}
        label={CONST.genero.label}
        onChange={(e) => _handleSetDataField(CONST.genero.name, e.target.value)}
      >
        <MenuItem value="M">Masculino</MenuItem>
        <MenuItem value="F">Femenino</MenuItem>
      </Select>
    </FormControl>
  );

  const selectTipoSangre = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.tipoSangre.name}`}>
        {CONST.tipoSangre.label}
      </InputLabel>
      <Select
        id={CONST.tipoSangre.name}
        value={data.tipoSangre}
        labelId={`label_${CONST.tipoSangre.name}`}
        label={CONST.tipoSangre.label}
        onChange={(e) =>
          _handleSetDataField(CONST.tipoSangre.name, e.target.value)
        }
      >
        <MenuItem value="A0">A-</MenuItem>
        <MenuItem value="A1">A+</MenuItem>
        <MenuItem value="B0">B-</MenuItem>
        <MenuItem value="B1">B+</MenuItem>
        <MenuItem value="AB0">AB-</MenuItem>
        <MenuItem value="AB1">AB+</MenuItem>
        <MenuItem value="O1">O+</MenuItem>
        <MenuItem value="O0">O-</MenuItem>
      </Select>
    </FormControl>
  );

  const selectRoles = (
    <SelectFieldRolesComponent
      value={data.rol}
      onChange={(rol) => _handleSetDataField(CONST.rol.name, rol)}
    />
  );

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={8}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Typography variant="h6">Información de perfil</Typography>
            </Grid>
            {/* <Grid item xs={12} md={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={data.dniEscolar}
                    onChange={(e) => {
                      _handleSetDataField(
                        CONST.dniEscolar.name,
                        e.target.checked,
                      );
                      if (e.target.checked) {
                        _handleSetDataField(CONST.rol.name, 'student');
                      } else {
                        _handleSetDataField(CONST.rol.name, 'entity');
                      }
                    }}
                  />
                }
                label={CONST.dniEscolar.quest}
              />
            </Grid> */}
            <Grid item xs={12} md={6}>
              {selectTipoDni}
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                id={CONST.dni.name}
                required
                label={
                  data.dniEscolar ? CONST.dniEscolar.family : CONST.dni.label
                }
                value={data.dni}
                onChange={(e) => {
                  let text = e.target.value;

                  if (data.tipoDni.toString() === 'V') {
                    text = text.replace(/[^0-9]/g, '');

                    if (!data.dniEscolar && text.length === 9) return;
                  }

                  let v = false;
                  if (data.tipoDni.toString() === 'P') {
                    if (text.length === 20) return;
                    v = text.match(ExpRegSoloNumerosPassport) != null;
                  } else {
                    v = text.match(ExpRegSoloNumeros) != null;
                  }

                  if (data.dniEscolar && text.length === 12) return;

                  if (text === '') {
                    _handleSetDataField(CONST.dni.name, e.target.value);
                    return;
                  }

                  if (!v) {
                    text = text.slice(0, -1);
                  }
                  _handleSetDataField(CONST.dni.name, text);
                }}
                helperText={dataError.dni ? validMessage.required : null}
                error={dataError.dni}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                id={CONST.papellido.name}
                required
                label={CONST.papellido.label}
                value={data.papellido}
                onChange={(e) =>
                  _handleSetDataField(
                    CONST.papellido.name,
                    e.target.value.toUpperCase(),
                  )
                }
                helperText={dataError.papellido ? validMessage.required : null}
                error={dataError.papellido}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                id={CONST.sapellido.name}
                label={CONST.sapellido.label}
                value={data.sapellido}
                onChange={(e) =>
                  _handleSetDataField(
                    CONST.sapellido.name,
                    e.target.value.toUpperCase(),
                  )
                }
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                id={CONST.pnombre.name}
                required
                label={CONST.pnombre.label}
                value={data.pnombre}
                onChange={(e) =>
                  _handleSetDataField(
                    CONST.pnombre.name,
                    e.target.value.toUpperCase(),
                  )
                }
                helperText={dataError.pnombre ? validMessage.required : null}
                error={dataError.pnombre}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                id={CONST.snombre.name}
                label={CONST.snombre.label}
                value={data.snombre}
                onChange={(e) =>
                  _handleSetDataField(
                    CONST.snombre.name,
                    e.target.value.toUpperCase(),
                  )
                }
              />
            </Grid>

            <Grid item xs={12} md={6}>
              {selectGenero}
            </Grid>
            <Grid item xs={12} md={6}>
              <FechaField
                views={['year', 'month', 'day']}
                openTo="year"
                botonCurrentDate={false}
                label={CONST.fechaNacimiento.label}
                value={data.fechaNacimiento}
                error={dataError.fechaNacimiento}
                onChange={(e) =>
                  _handleSetDataField(
                    CONST.fechaNacimiento.name,
                    dateformat(e, {}),
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={3}>
              {selectTipoSangre}
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={data.internet}
                    onChange={(e) => {
                      _handleSetDataField(
                        CONST.internet.name,
                        e.target.checked,
                      );
                    }}
                  />
                }
                label={CONST.internet.quest}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={data.actividadExtcur}
                    onChange={(e) => {
                      _handleSetDataField(
                        CONST.actividadExtcur.name,
                        e.target.checked,
                      );
                    }}
                  />
                }
                label={CONST.actividadExtcur.quest}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={4}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Typography variant="h6">Usuario</Typography>
            </Grid>

            {loginStore.isRoot && isUsuarios && (
              <Grid item xs={12} md={12}>
                {selectRoles}
              </Grid>
            )}

            {data.rol !== ROOT_CONST && isSelectEntidad && isUsuarios && (
              <Grid item xs={12} md={12}>
                {selectEntidades}
              </Grid>
            )}

            {((![ROOT_CONST, ADMIN_CONST].includes(data.rol) && isUsuarios) ||
              isPerfiles) && (
              <Grid item xs={12} md={12}>
                {selectPerfiles}
                <Typography variant="caption">
                  Rol: {rolesArray[data.rol]}
                </Typography>
              </Grid>
            )}

            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                size="small"
                id={CONST.correo.name}
                required
                label={CONST.correo.label}
                value={data.correo}
                onChange={(e) =>
                  _handleSetDataField(CONST.correo.name, e.target.value)
                }
                helperText={dataError.correo ? validMessage.required : null}
                error={dataError.correo}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                size="small"
                id={CONST.username.name}
                required
                label={CONST.username.label}
                value={data.username}
                onChange={(e) =>
                  _handleSetDataField(CONST.username.name, e.target.value)
                }
                helperText={dataError.username ? validMessage.required : null}
                error={dataError.username}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                size="small"
                id={CONST.password.name}
                required={!activo}
                label={CONST.password.label}
                value={data.password}
                onChange={(e) =>
                  _handleSetDataField(CONST.password.name, e.target.value)
                }
                helperText={
                  !activo && dataError.password ? validMessage.required : null
                }
                error={activo ? null : dataError.password}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              {loginStore.isRoot ||
              !activo ||
              (loginStore.isAdmin && activo?.estatus.id === 1) ? (
                <EstatusField
                  value={data.idEstatus}
                  ignored={!login.isRoot ? [5] : null}
                  onChange={(e) =>
                    _handleSetDataField(CONST.estatus.idName, e.target.value)
                  }
                  allowIds={[1, 2, 6]}
                />
              ) : (
                <>
                  <Typography sx={{ fontSize: 15 }}>
                    {CONST.estatus.label}
                  </Typography>
                  <Chip
                    label={activo?.estatus.nombre}
                    size="small"
                    color={activo?.estatus.id === 1 ? 'success' : 'error'}
                  />
                </>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green
            mr={2}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormNuevoUsuariosComponent;
